module.exports = __webpack_public_path__ + "img/logo1.fa4b44ca.png";